import React from "react";
import video from "../../img/main.mp4";

function Video() {
  return (
    <div className="background-video">
      <video autoPlay loop muted playsInline>
        <source src={video} type="video/mp4" />
      </video>
    </div>
  );
}

export default Video;
